export default "__VITE_ASSET__Dc$sX1BN__"